import axios from "@/utils/axios";
import { asArray } from "@/utils/apiResponse";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getClientsData = async () => {
  const response = await axios.get(`${API_URL}/clients`);
  return asArray(response.data);
};

export const createClient = async (data) => {
  const response = await axios.post(`${API_URL}/clients`, data);
  return response.data.data;
};

export const checkClientEmail = async (email, ignoreId = null) => {
  const response = await axios.get(`${API_URL}/clients/email/check`, {
    params: {
      email,
      ignore_id: ignoreId ?? undefined,
    },
  });
  return response.data;
};

export const deleteClient = async (id) => {
  const response = await axios.delete(`${API_URL}/clients/${id}`);
  return response.data;
};

export const updateClient = async (id, data) => {
  const response = await axios.put(`${API_URL}/clients/${id}`, data);
  return response.data.data;
}; 

export const getClient = async (id) => {
  const response = await axios.get(`${API_URL}/clients/${id}`);
  return response.data.data;
}
